import PropTypes from 'prop-types';
import { Button } from '@gusto/workbench';

const Pager = ({ page, totalResults, resultsPerPage, onPageChange }) => {
  if (totalResults <= resultsPerPage) return null;

  const totalPages = Math.ceil(totalResults / resultsPerPage);
  const previousPage = page - 1;
  const nextPage = page + 1;
  const hasPreviousPage = page !== 1;
  const hasNextPage = page < totalPages;
  const infoStart = (page - 1) * resultsPerPage + 1;
  const infoLast = page === totalPages ? totalResults : infoStart - 1 + resultsPerPage;

  return (
    <div className="pager">
      <div>
        <Button onClick={() => onPageChange(previousPage)} size="small" disabled={!hasPreviousPage}>
          Prev
        </Button>
        <Button onClick={() => onPageChange(nextPage)} size="small" disabled={!hasNextPage}>
          Next
        </Button>
      </div>

      <div className="pageInfo">
        Showing {infoStart} - {infoLast} of {totalResults}
      </div>
    </div>
  );
};

Pager.propTypes = {
  page: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired,
  resultsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pager;
